"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateFixUnlinkedSteps = void 0;
/**
 * This migration got introduced because some stories have the navigation linked wrong.
 * The case observed was that 2 steps had the same previous id.
 * The migration is intended to go through the navigation using 'next' to iterate through and correct the 'previous' value
 */
const linkSteps = (steps, initialId) => {
    const initialStep = steps.find((step) => step.navigation.id === initialId);
    if (!initialStep) {
        throw Error(`Error: Cannot find 'initialStep' in 'linkSteps()'`);
    }
    // Start iterating from the second step since first step doesn't have 'previous'
    let nextStep = steps.find((step) => step.navigation.id === initialStep.navigation.next);
    let previousStep = initialStep;
    while (nextStep) {
        // set the step previous as the id of the previous step
        nextStep.navigation.previous = previousStep.navigation.id;
        // move cursor to next step until we cant find any more next
        previousStep = nextStep;
        nextStep = steps.find((step) => step.navigation.id === nextStep.navigation.next);
    }
    return steps;
};
const migrateFixUnlinkedSteps = async (dialog) => {
    const steps = dialog.steps;
    const lastRootStep = steps.find((step) => step.choices);
    const storylineIds = (lastRootStep === null || lastRootStep === void 0 ? void 0 : lastRootStep.choices)
        ? [undefined].concat(Object.values(lastRootStep.choices).map((v) => v.navigation.parent))
        : [undefined];
    const newSteps = [];
    storylineIds.forEach((storyline) => {
        const storylineSteps = steps.filter((step) => step.navigation.parent === storyline);
        const initialId = storyline ? storyline.split('/')[1] : dialog.initialStep;
        newSteps.push(...linkSteps(storylineSteps, initialId));
    });
    dialog.steps = newSteps;
    return dialog;
};
exports.migrateFixUnlinkedSteps = migrateFixUnlinkedSteps;
//# sourceMappingURL=migrateFixUnlinkedSteps.js.map